import LocalStorageAdapter from "./LocalStorageAdapter/LocalStorageAdapter";
import SessionStorageAdapter from "./SessionStorageAdapter/SessionStorageAdapter";
import { StorageService } from "./StorageService/StorageService";

export const localStorageService = new StorageService(new LocalStorageAdapter());

export const sessionStorageService = new StorageService(new SessionStorageAdapter());
